import React, { useState, useRef } from "react";
import { ChipGroup } from "cai-fusion";

const TagsEditor = ({ chatTemplate, setChatTemplate, trackPropertyChange }) => {
    // A list of all the available tags
    const availableTags = ['Content Summarization', 'Coding', 'Brainstorming', 'Data Analysis', 'Creative Writing', 'Translation', 'Question Answering', 'Text Completion', 'Text Classification', 'Paraphrasing'];
    
    // The state of the tag input, used for searching the above list.
    const [tagsInput, setTagsInput] = useState("");
    // The visual state to manage the autocomplete options showing.
    const [showTags, setShowTags] = useState(false);
    // The reference to the tag input
    const tagsRef = useRef(null);

    // These two functions simply add and remove the given tag from the tags list in the form object.
    const addTag = (tag) => {
        // If it's not already in the list of used tags, add it to the list.
        if (!chatTemplate?.tags?.includes(tag)) {
            setChatTemplate({...chatTemplate, tags: [...(chatTemplate?.tags || []), tag]})
            
            // Track the addition for API call
            trackPropertyChange('tags', 'added', [tag]);
        }
        setTagsInput("");
    }
    
    const removeTag = (tag) => {
        setChatTemplate({...chatTemplate, tags: [...(chatTemplate?.tags || []).filter((tagItem) => tagItem !== tag)]})
        
        // Track the removal for API call
        trackPropertyChange('tags', 'removed', [tag]);
    }

    // When the enter key is pressed & the tags input is in focus, add that tag
    const handleTagsKey = (key) => {
        if (key === 'Enter') {
            // This will remove focus from the input.
            tagsRef.current?.blur();
            addTag(tagsInput);
        }
    }

    return (
        <>
            {/* Tags Field */}
            <div className="m-form-group">
                <label htmlFor="addTagInput" className="a-label">Tags</label>
                <p className="a-subtle-text a-muted-text">You can assign tags to a template to help group it with similar templates on users' new chat screen.</p>
                <div className="m-autocomplete-input" id="tag-autocomplete">
                    <label className="visually-hidden" htmlFor="autocompleteInput"></label>
                    <input 
                        id="addTagInput" 
                        type="text" 
                        placeholder="Add a tag..." 
                        className="a-text-input"
                        value={tagsInput}
                        onChange={(e) => setTagsInput(e.target.value)}
                        onKeyDown={(e) => handleTagsKey(e.key)}
                        onFocus={() => setShowTags(true)}
                        onBlur={() => setTimeout(() => setShowTags(false), 200)}
                        ref={tagsRef}
                    />
                    <div className={`m-autocomplete-input__dropdown ${showTags ? `m-autocomplete-input__dropdown--shown` : ""}`} id="autocompleteDropdown">
                        {availableTags
                            .filter((tag) => tag.toLowerCase().includes(tagsInput.toLowerCase()))
                            .filter((tag) => !(chatTemplate?.tags || []).includes(tag)) // Filter out already used tags
                            .map((tag) => (
                            <button 
                                className="m-autocomplete-input__dropdown-item" 
                                key={tag}
                                onClick={() => addTag(tag)}
                            >
                                <div className="m-autocomplete-input__dropdown-item-title">{tag}</div>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
            {/* Chips associated with the selected tags */}
            <ChipGroup 
                chipTexts={chatTemplate?.tags ?? []}
                onClose={(chipText) => removeTag(chipText)}
            />
        </>
    );
};

export default TagsEditor;
